<template>
  <div class="settings-overlay-container" @click.stop="">
    <div class="settings-overlay-card">
      <div class="title-label">
        Your total pipe length is longer than your total slope length.
      </div>
      <div class="title-label">
        Would you like to...
      </div>
      <div class="buttons-container">
        <div class="option-button" @click="handleExtendPreviousSlope">
          Extend Previous Slope
        </div>
        <div class="or-label">
          OR
        </div>
        <div class="option-button" @click="handleAddZeroSlope">
          Add 0% Slope
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import { useSegmentStore } from '@/store/SegmentStore';

export default {
  name: 'ModalSlopeExtend',
  methods: {
    handleExtendPreviousSlope () {
      this.makeSlopesMatch();
      useModalStore().hideModal();
    },
    handleAddZeroSlope () {
      useSegmentStore().addDefaultSegmentForType('slope');
      this.makeSlopesMatch();
      useModalStore().hideModal();
    },
    makeSlopesMatch () {
      const segmentStore = useSegmentStore();
      const lastSlope = segmentStore.lastSegmentOfType('slope');
      lastSlope.value += segmentStore.getAllSegmentLengths('pipe') - segmentStore.getAllSegmentLengths('slope');
      lastSlope.endPosition = lastSlope.startPosition + lastSlope.value;
    }
  }
};
</script>

<style scoped>
.settings-overlay-container {
  background-color: white;
  border: 3px solid red;
  height: 130px;
  margin-top: 40vh;
  margin-right: 10vh;
  width: 500px;
}
.settings-overlay-card {
  height: 100%;
  width: 100%;
}
.title-label {
  display: flex;
  justify-content: center;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
}
.buttons-container {
  display: flex;
  margin-left: 5%;
  margin-top: 20px;
  width: 90%;
}
.option-button {
  border: 1px solid black;
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 40%;
}
.or-label {
  display: flex;
  justify-content: center;
  width: 20%;
}
</style>
